import '../social_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.DatasiftContent extends Monitoring.Models.SocialContents.SocialContent

  initialize: (json) ->
    super(json)

  type: ->
    return @interaction().type

  content: ->
    return @interaction().content

  userId: ->
    return @interaction().author.id

  username: ->
    return @interaction().author.username

  name: ->
    return @interaction().author.name

  avatar: ->
    return @interaction().author.avatar

  created_at: ->
    return @interaction().created_at

  userLink: ->
    @interaction().author.link

  link: ->
    console.log('not implemented method: link')
